import
{ NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { AssinadorDocumentosComponent } from "./assinador-documentos.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { MyPipesModule } from "../core/my-pipes/my-pipes.module";
import { NgxUploaderModule } from "ngx-uploader";
import {InputTextModule} from "primeng/inputtext";
import {SelectModule} from "primeng/select";
import {ReactiveFormsModule} from "@angular/forms";
import { FormsModule } from "@angular/forms";

import { SharedsModule } from '../shareds/shareds.module';

@NgModule({
    imports: [
    SharedsModule,
    CommonModule,
        RouterModule,
        PdfViewerModule,
        MyPipesModule,
        NgxUploaderModule,
        SelectModule,
        InputTextModule,
        ReactiveFormsModule,
        FormsModule,
    ],
  declarations: [AssinadorDocumentosComponent],
})
export class AssinadorDocumentosModule {}
